import { __assign, __extends } from "tslib";
import * as React from 'react';
import { st, classes } from './NavStepper.st.css';
import { Stepper } from '../stepper';
import { NavStep } from './NavStep';
import { filterDataProps } from '../../utils/filter-data-props';
var NavStepper = /** @class */ (function (_super) {
    __extends(NavStepper, _super);
    function NavStepper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavStepper.prototype.render = function () {
        var _this = this;
        var _a = this.props, activeStep = _a.activeStep, children = _a.children, className = _a.className;
        return (React.createElement("nav", __assign({ className: st(classes.root, className) }, filterDataProps(this.props)),
            React.createElement(Stepper, { activeStep: activeStep }, function (_a) {
                var getStepProps = _a.getStepProps;
                return (React.createElement("ol", { className: classes.steps }, React.Children.map(children, function (child, index) {
                    if (React.isValidElement(child)) {
                        var stepProps = getStepProps(index, __assign(__assign({}, child.props), { className: classes.step }));
                        if (_this.props.onStepClick &&
                            !(stepProps.active || stepProps.disabled)) {
                            stepProps.onClick = function (e) {
                                return _this.props.onStepClick(index, e);
                            };
                        }
                        return React.cloneElement(child, stepProps);
                    }
                    return child;
                })));
            })));
    };
    NavStepper.Step = NavStep;
    return NavStepper;
}(React.PureComponent));
export { NavStepper };
//# sourceMappingURL=NavStepper.js.map